<h1 mat-dialog-title>Select Your Role</h1>
<div mat-dialog-content class="dialog-content">
    <span><b>Operator</b></span> <span>Actively monitor and control the docking</span>
    <span class="dialog-content-margin"><b>Viewer</b> </span> <span>View Safedock state</span>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="false">Viewer</button>
    <button mat-raised-button color="primary" class="critical" [mat-dialog-close]="true">Operator</button>
</div>
